<template>
  <div
    class="button-shadow inline-block"
    :class="[shadowClass, hasShadow ? 'has-shadow' : '']"
  >
    <div
      class="relative flex items-center rounded-[50px] border border-solid border-black bg-black p-3 text-base leading-6"
    >
      <span
        v-if="text && type === 'arrow'"
        class="mx-2 hidden text-white group-hover:inline"
      >
        {{ text }}
      </span>
      <div class="rounded-full">
        <component
          :is="type === 'play' ? IconPlay : IconArrow"
          v-bind="type === 'arrow' ? { direction: 'right' } : {}"
          class="h-6 w-6 text-white"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import IconArrow from '@/components/Icon/Arrow.vue';
  import IconPlay from '@/components/Icon/Play.vue';

  interface IProps {
    type?: 'play' | 'arrow';
    text?: string;
    theme?: TTheme;
    hasShadow?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    type: 'arrow',
    text: '',
    theme: 'blue',
    hasShadow: false,
  });

  const shadowClass = computed((): string => {
    switch (props.theme) {
      case 'blue':
        return 'before:from-blue-400 before:to-blue-400';
      case 'green':
        return 'before:from-blue-400 before:to-green-400';
      case 'cyan':
        return 'before:from-blue-400 before:to-cyan-400';
      case 'purple':
        return 'before:from-blue-400 before:to-purple-400';
      case 'yellow':
        return 'before:from-blue-400 before:to-yellow-400';
      default:
        return '';
    }
  });
</script>

<style lang="scss" scoped>
  .button-shadow {
    @apply before:bg-gradient-to-r group-hover:before:opacity-100 group-hover:before:blur-lg;

    &.has-shadow {
      @apply before:opacity-100 before:blur-lg;
    }

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      transform: translateZ(-1px);
      pointer-events: none;
      transition-property: all, inset;
      transition-duration: 0.3s;
      transition-timing-function: ease;
      background-clip: content-box !important;
      padding: 1px;
      opacity: 0;
    }
  }
</style>
